import _extends from "@babel/runtime/helpers/extends";
import { Checkbox, TableCell } from '@material-ui/core';
import React from 'react';
export const RowCheckbox = props => {
  return /*#__PURE__*/React.createElement(TableCell, {
    style: {
      height: '57px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0
    },
    component: "div",
    padding: "checkbox",
    key: "select"
  }, props.getSelectionControl ? props.getSelectionControl(props.isSelected, props.rowData, () => props.handleContentSelection(props.rowData)) : /*#__PURE__*/React.createElement(Checkbox, _extends({
    checked: props.isSelected ? true : false,
    onChange: () => props.handleContentSelection(props.rowData)
  }, props.checkboxProps)));
};
//# sourceMappingURL=RowCheckBox.js.map